export default __webpack_public_path__ + "static/media/property3.15cabb67.png";